import { cn } from '@/utils/cn';
import React from 'react';

interface ColorPickerProps {
  name: string;
  selectedColor: string | null;
  onChange: (e: { target: { value: string; name: string } }) => void;
  label?: string;
  colors?: Array<{ value: string; label: string }>;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({
  name,
  selectedColor,
  onChange,
  label,
  colors = [
    { value: '#FFFFFF', label: 'White' },
    { value: '#A7F3D0', label: 'Mint Glass' },
    { value: '#34D399', label: 'Emerald Glass' },
    { value: '#2DD4BF', label: 'Teal Glass' },
    { value: '#22D3EE', label: 'Cyan Glass' },
    { value: '#38BDF8', label: 'Sky Glass' },
    { value: '#818CF8', label: 'Indigo Glass' },
    { value: '#A78BFA', label: 'Violet Glass' },
    { value: '#E879F9', label: 'Fuchsia Glass' },
    { value: '#FB7185', label: 'Rose Glass' },
    { value: '#FBBF24', label: 'Amber Glass' },
  ],
}) => {
  const handleColorChange = (colorValue: string) => {
    const event = {
      target: {
        name,
        value: colorValue,
      },
    };

    onChange(event);
  };

  return (
    <div className="flex flex-col space-y-2">
      {label && (
        <label className="text-xs font-medium text-gray-600">{label}</label>
      )}
      <div className="flex flex-wrap items-center gap-2">
        {colors.map(color => (
          <button
            key={color.value}
            type="button"
            aria-label={`Select ${color.label} color`}
            className={cn(
              'size-8 rounded-full',
              selectedColor === color.value
                ? 'ring-2 ring-linko-dark'
                : 'ring-1 ring-gray-light',
            )}
            style={{ backgroundColor: color.value }}
            onClick={() => handleColorChange(color.value)}
          />
        ))}
      </div>
    </div>
  );
};
